import 'styles/age_verification/address-form.scss';

import React from 'react';
import { intlShape } from 'react-intl';

import { messageTranslator } from 'common/components/Intl';
import PropTypes from '../../propTypes';
import * as f from 'common/components/Form';
import * as m from '../../messages';

class BaseAddressForm extends React.Component {
  static contextTypes = {
    intl: intlShape,
  };

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.AgeVerification,
    onSave: PropTypes.func.isRequired,
    onSubmitSuccess: PropTypes.func.isRequired,
    currentValues: PropTypes.object,
    features: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);
    this.translate = messageTranslator(this.context.intl);
    this.submitHandler = this.props.handleSubmit(this.handleSubmit.bind(this));

    this.state = {
      modalIsOpen: false,
      confirmed: !this.props.confirmSubmit,
      selectedState: {},
    };
  }

  onConfirm() {
    this.setState(
      {
        modalIsOpen: false,
        confirmed: true,
      },
      this.submitHandler
    );
  }

  handleSubmit(values) {
    if (this.state.confirmed) {
      return this.props.onSave(values).catch(error => {
        this.setState({ confirmed: false });
        const errorMessage =
          error.message || this.translate(m.ERROR_UNEXPECTED);
        throw new f.SubmissionError({ _error: errorMessage });
      });
    }

    return this.showConfirmationModal();
  }

  onAddressSelect = address => {
    if (address) {
      address.zip = address.zipcode;

      Object.keys(address).forEach(key => {
        this.props.change(key, address[key]);
        if (key === 'state') {
          this.updateFormStateValue(address[key]);
        }
      });
    }
  };

  updateFormStateValue(selectedState) {
    this.setState({ selectedState });
  }

  showConfirmationModal() {
    this.setState({ modalIsOpen: true });
  }

  hideConfirmationModal() {
    this.setState({ modalIsOpen: false, confirmed: false });
  }
}

export default BaseAddressForm;



// WEBPACK FOOTER //
// ./app/javascript/apps/age_verification/components/forms/BaseAddressForm.js